import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import FutureIcon from '@material-ui/icons/FastRewind'
import TimeSliderActions from '../redux/timeSliderRedux'
import TimestampActions from '../redux/timestampRedux'
import Tooltip from '@material-ui/core/Tooltip'
import PaperIcon from './PaperIcon'
import isEmptyObject from '../utility/isEmptyObject'

const styles = theme => ({
  container: {
    paddingTop: 10,
    paddingBottom: 10
  },
  button: {},
  empty: {},
  icon: {
    transform: 'rotate(-90deg)'
  }
})

const ButtonPreviousDatetime = props => {
  const { actions, classes, marks } = props

  if (!marks || (marks && isEmptyObject(marks))) {
    return <div className={classes.empty} />
  }

  return (
    <div className={classes.container}>
      <PaperIcon>
        <Tooltip placement='top-start' id='tooltip-previous-year' title='previous year'>
          <IconButton
            color='primary'
            className={classes.icon}
            onClick={actions.seasonDecremented}
          >
            <FutureIcon />
          </IconButton>
        </Tooltip>
      </PaperIcon>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    marks: state.timeSlider.marks || {}
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      seasonDecremented: () => dispatch(TimestampActions.seasonDecremented()),
      timeSliderValueDecremented: () =>
        dispatch(TimeSliderActions.timeSliderValueDecremented()),
      timeSliderValueIncremented: () =>
        dispatch(TimeSliderActions.timeSliderValueIncremented())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ButtonPreviousDatetime)
)



// WEBPACK FOOTER //
// ./src/components/ButtonPastYear.js